var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.s.container, { [_vm.s.bottom]: _vm.isBottom }],on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }